export default __webpack_public_path__ + "static/media/Maven.d5ea92de.png";